import React from 'react';

interface IconProps {
  name: String,
  style?: React.CSSProperties
}
const Icon:React.FC<IconProps> = ({
  name='',
  style={}
}) => {
  return (
    <i className={`iconfont icon-${name}`} style={style}></i>
  )
}

export default Icon;